import utils from '@/app/utils/gfUtils';
import HELPER from '@/app/utils/HELPER';
import {getDefaultImage} from "@/app/utils/assignedProductHelper";

(function (jQuery) {
  jQuery.gfFormRender = function (element, options) {
    const defaults = {
      fields: [],
      onRender: function () {},
    };
    this.settings = {};

    const $element = jQuery(element);
    const _this = this;

    /* Editor */
    const $gfResTool = jQuery('#gfResTool');

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      const fields = _this.settings.fields;
      const html = _this.renderForm(fields);

      $element.empty();
      $element.html(html);
      _this.settings.onRender();

      return false;
    };

    this.renderFormField = function (field, type) {
      if (type == undefined) {
        type = 'settings';
      }
      let template = '';
      if (field == undefined) {
        return template;
      }

      const name = field.name != undefined ? field.name : '';
      const unitType = field.unitType != undefined ? field.unitType : '';
      const id = field.id != undefined ? field.id : '';
      let defaultValue = field.default_value != undefined ? field.default_value : '';
      const defaultValueImage = field.default_value_image ? field.default_value_image : getDefaultImage();
      let description = field.desc != undefined ? field.desc : '';
      description = description.replace(/"/gi, "'");
      let caption = field.caption != undefined ? field.caption : '';
      caption = caption.replace(/"/gi, "'");
      let placeholder = field.placeholder != undefined ? field.placeholder : '';
      if (!defaultValue && field.name == 'defaultvalue' && field.requires && field.requires.includes('hideOnClient')) {
        defaultValue = window.___gemShopInfo.email
        placeholder = defaultValue
      }
      const visible = field.visible != undefined ? field.visible : '';
      const readOnly = field.readonly != undefined ? 'readonly="' + field.readonly + '"' : '';
      const requires = field.requires != undefined ? 'requires="' + field.requires + '"' : '';

      let cssClass = field.class != undefined ? field.class : '';
      const cssClassString = 'gf-field-item ' + cssClass + ' ' + visible;
      const cssClassArray = jQuery.trim(cssClass).split(' ');

      const targetClass = field.target != undefined ? field.target : '';
      const reference = field.ref != undefined ? field.ref : '';

      if (cssClassArray.length > 1) {
        cssClass = cssClassArray[0];
      }

      switch (field.type) {
        case 'div':
          template +=
            '<div class="' +
            cssClassString +
            '" reference="' +
            reference +
            '" targetclass="' +
            targetClass +
            '"  data-caption="' +
            caption +
            '"></div>';
          break;
        case 'span':
          if (field.html != undefined) {
            description = field.html;
          }
          template +=
            '<span ' +
            requires +
            ' class="gfDesc" reference="' +
            reference +
            '" targetclass="' +
            targetClass +
            '">' +
            description +
            '</span>';
          break;
        case 'textarea':
          template +=
            '<textarea type="text" ' +
            requires +
            ' ' +
            readOnly +
            ' name="' +
            name +
            '" id="' +
            id +
            '" class="' +
            cssClassString +
            '" reference="' +
            reference +
            '" targetclass="' +
            targetClass +
            '" value="' +
            defaultValue +
            '" default_value="' +
            defaultValue +
            '" data-description="' +
            description +
            '" data-caption="' +
            caption +
            '"></textarea>';
          break;
        case 'color':
        case 'input':
        case 'text':
          if (field.type == 'color' || id == 'success_color' || id == 'error_color') {
            cssClass = 'gryff-color';
          }
          switch (cssClass) {
            case 'gf_to-align':
              var options = field.options != undefined ? field.options : {};
              template +=
                '<select ' +
                requires +
                ' ' +
                readOnly +
                ' name="' +
                name +
                '" id="' +
                id +
                '" class="' +
                cssClassString +
                '" reference="' +
                reference +
                '" targetclass="' +
                targetClass +
                '" value="' +
                defaultValue +
                '" default_value="' +
                defaultValue +
                '" data-description="' +
                description +
                '" data-caption="' +
                caption +
                '">';
              for (var key in options) {
                template += '<option value="' + key + '">' + options[key] + '</option>';
              }
              template += '</select>';
              break;
            case 'gryff-color':
              template +=
                '<input type="text" ' +
                requires +
                ' ' +
                readOnly +
                ' name="' +
                name +
                '" id="' +
                id +
                '" class="' +
                cssClassString +
                '" reference="' +
                reference +
                '" targetclass="' +
                targetClass +
                '" data-hide="true" value="' +
                defaultValue +
                '" default_value="' +
                defaultValue +
                '" data-description="' +
                description +
                '" data-caption="' +
                caption +
                '"  />';
              break;
            case 'gf_to-range':
              var min = field.min != undefined ? field.min : 0;
              var max = field.max != undefined ? field.max : 100;
              var warn_gt = field.warn_gt != undefined ? field.warn_gt : 20;
              var step = field.step != undefined ? field.step : 1;
              var unit = field.unit != undefined ? field.unit : '';
              var warn_text = field.warn_text != undefined ? field.warn_text : '';

              template +=
                '<input type="text" ' +
                requires +
                ' ' +
                readOnly +
                ' name="' +
                name +
                '" id="' +
                id +
                '" class="' +
                cssClassString +
                '" reference="' +
                reference +
                '" targetclass="' +
                targetClass +
                '" min="' +
                min +
                '" max="' +
                max +
                '" warn_gt="' +
                warn_gt +
                '" step="' +
                step +
                '" unit="' +
                unit +
                '" value="' +
                defaultValue +
                '" default_value="' +
                defaultValue +
                '" data-description="' +
                description +
                '" warn_text="' +
                warn_text +
                '" data-caption="' +
                caption +
                '" />';
              break;

            case 'gf_to-segment':
              var dataValue = field.dataValue;
              var value = field.default_value != undefined ? field.default_value : '';
              var dataColumns = field.columns;
              var dataDisable = field.disable != undefined ? field.disable : 'true';
              var dataMultiple = field.multiple != undefined ? field.multiple : 'false';
              var dataIcon = field.icon != undefined ? field.icon : 'false';
              template +=
                '<input type="text" ' +
                requires +
                ' ' +
                readOnly +
                ' name="' +
                name +
                '" id="' +
                id +
                '" class="' +
                cssClassString +
                '" reference="' +
                reference +
                '" targetclass="' +
                targetClass +
                '" data-multiple="' +
                dataMultiple +
                '" data-icon="' +
                dataIcon +
                '" data-value="' +
                dataValue +
                '" data-columns="' +
                dataColumns +
                '" value="' +
                value +
                '" data-disable="' +
                dataDisable +
                '" data-description="' +
                description +
                '" data-caption="' +
                caption +
                '" />';
              break;

            default:
              if (name == 'width' || id == 'video-width' || id == 'buttonWidth' || unitType == 'dynamic') {
                var unit = field.unit != undefined ? field.unit : 'px';
                template +=
                  '<input type="text" ' +
                  requires +
                  ' ' +
                  readOnly +
                  ' name="' +
                  name +
                  '" id="' +
                  id +
                  '" class="' +
                  cssClassString +
                  '" reference="' +
                  reference +
                  '" targetclass="' +
                  targetClass +
                  '" value="' +
                  defaultValue +
                  '" default_value="' +
                  defaultValue +
                  '" data-description="' +
                  description +
                  '" unit="' +
                  unit +
                  '" data-unit="' +
                  (field.list_unit != undefined && field.list_unit != '' ? field.list_unit : '%,px') +
                  '" placeholder="auto" data-caption="' +
                  caption +
                  '" />';
              } else if (name == 'height' || unitType == 'dynamic') {
                var unit = field.unit != undefined ? field.unit : 'px';
                const list_unit = field.list_unit != undefined ? 'data-unit="' + field.list_unit + '"' : '';
                template +=
                  '<input type="text" ' +
                  requires +
                  ' ' +
                  readOnly +
                  ' name="' +
                  name +
                  '" id="' +
                  id +
                  '" class="' +
                  cssClassString +
                  '" reference="' +
                  reference +
                  '" targetclass="' +
                  targetClass +
                  '" value="' +
                  defaultValue +
                  '" default_value="' +
                  defaultValue +
                  '" data-description="' +
                  description +
                  '" unit="' +
                  unit +
                  '" ' +
                  list_unit +
                  ' placeholder="auto" data-caption="' +
                  caption +
                  '" />';
              } else if (id == 'swatcher') {
                defaultValue = defaultValue.replace(/"/gi, "'");
                template +=
                  '<input type="text" ' +
                  requires +
                  ' ' +
                  readOnly +
                  ' name="' +
                  name +
                  '" id="' +
                  id +
                  '" class="' +
                  cssClassString +
                  '" reference="' +
                  reference +
                  '" targetclass="' +
                  targetClass +
                  '" value="' +
                  defaultValue +
                  '" data-description="' +
                  description +
                  '" placeholder="' +
                  placeholder +
                  '" data-caption="' +
                  caption +
                  '" />';
              } else if (name == 'editLink') {
                const option = field.option != undefined ? field.option : 'default';
                template +=
                  '<input type="text" ' +
                  requires +
                  ' ' +
                  readOnly +
                  ' data-option="' +
                  option +
                  '" name="' +
                  name +
                  '" id="' +
                  id +
                  '" class="' +
                  cssClassString +
                  '" reference="' +
                  reference +
                  '" targetclass="' +
                  targetClass +
                  '" value="' +
                  defaultValue +
                  '" default_value="' +
                  defaultValue +
                  '" data-description="' +
                  description +
                  '" placeholder="' +
                  placeholder +
                  '" data-caption="' +
                  caption +
                  '" />';
              } else if(name === 'product') {
                template +=
                  '<input type="text" ' +
                  requires +
                  ' ' +
                  readOnly +
                  ' name="' +
                  name +
                  '" id="' +
                  id +
                  '" class="' +
                  cssClassString +
                  '" reference="' +
                  reference +
                  '" targetclass="' +
                  targetClass +
                  '" value="' +
                  defaultValue +
                  '" default_value="' +
                  defaultValue +
                  '" data-description="' +
                  description +
                  '" data-default-image="' +
                  defaultValueImage +
                  '" placeholder="' +
                  placeholder +
                  '" data-caption="' +
                  caption +
                  '" />';
              } else {
                template +=
                  '<input type="text" ' +
                  requires +
                  ' ' +
                  readOnly +
                  ' name="' +
                  name +
                  '" id="' +
                  id +
                  '" class="' +
                  cssClassString +
                  '" reference="' +
                  reference +
                  '" targetclass="' +
                  targetClass +
                  '" value="' +
                  defaultValue +
                  '" default_value="' +
                  defaultValue +
                  '" data-description="' +
                  description +
                  '" placeholder="' +
                  placeholder +
                  '" data-caption="' +
                  caption +
                  '" />';
              }
              break;
          }
          break;
        case 'align':
        case 'select':
          switch (cssClass) {
            case 'gf_to-align':
              var options = field.options != undefined ? field.options : {};
              var dataDisable = field.disable != undefined ? field.disable : 'false';
              template +=
                '<select data-disable="' +
                dataDisable +
                '" ' +
                requires +
                ' ' +
                readOnly +
                ' name="' +
                name +
                '" id="' +
                id +
                '" class="' +
                cssClassString +
                '" reference="' +
                reference +
                '" targetclass="' +
                targetClass +
                '" value="' +
                defaultValue +
                '" default_value="' +
                defaultValue +
                '" data-description="' +
                description +
                '" data-caption="' +
                caption +
                '">';
              for (var key in options) {
                template += '<option value="' + key + '">' + options[key] + '</option>';
              }
              template += '</select>';
              break;

            default:
              var options = field.options != undefined ? field.options : {};
              var dataDisable = field.disable != undefined ? field.disable : 'false';
              if (field.type == 'align') {
                cssClass += ' gf_to-align';
              }
              template +=
                '<select data-disable="' +
                dataDisable +
                '" ' +
                requires +
                ' ' +
                readOnly +
                ' name="' +
                name +
                '" id="' +
                id +
                '" class="' +
                cssClassString +
                '" reference="' +
                reference +
                '" targetclass="' +
                targetClass +
                '" default_value="' +
                defaultValue +
                '" data-description="' +
                description +
                '" data-caption="' +
                caption +
                '">';
              for (var key in options) {
                template += '<option value="' + key + '">' + options[key] + '</option>';
              }
              template += '</select>';
              break;
          }
          break;
        case 'range':
          var min = field.min != undefined ? field.min : 0;
          var max = field.max != undefined ? field.max : 100;
          var step = field.step != undefined ? field.step : 1;
          var unit = field.unit != undefined ? field.unit : '';

          template +=
            '<input type="text" ' +
            requires +
            ' ' +
            readOnly +
            ' name="' +
            name +
            '" id="' +
            id +
            '" class="gf_to-range" reference="' +
            reference +
            '" targetclass="' +
            targetClass +
            '" min="' +
            min +
            '" max="' +
            max +
            '" step="' +
            step +
            '" unit="' +
            unit +
            '" value="' +
            defaultValue +
            '" default_value="' +
            defaultValue +
            '" data-description="' +
            description +
            '" data-caption="' +
            caption +
            '" />';
          break;

        case 'datepicker':
          template +=
            '<input type="text" ' +
            requires +
            ' ' +
            readOnly +
            ' name="' +
            name +
            '" id="' +
            id +
            '" class="gf_to-datePicker ' +
            cssClassString +
            '" reference="' +
            reference +
            '" targetclass="' +
            targetClass +
            '" value="' +
            defaultValue +
            '" default_value="' +
            defaultValue +
            '" data-description="' +
            description +
            '" placeholder="' +
            placeholder +
            '" data-caption="' +
            caption +
            '" />';
          break;

        case 'switch':
          template +=
            '<input type="text" ' +
            requires +
            ' ' +
            readOnly +
            ' name="' +
            name +
            '" id="' +
            id +
            '" class="gf_to-switch ' +
            cssClassString +
            '" reference="' +
            reference +
            '" targetclass="' +
            targetClass +
            '" value="' +
            defaultValue +
            '" default_value="' +
            defaultValue +
            '" data-description="' +
            description +
            '" placeholder="' +
            placeholder +
            '" data-caption="' +
            caption +
            '" />';
          break;

        default:
          template +=
            '<input type="text" ' +
            requires +
            ' ' +
            readOnly +
            ' name="' +
            name +
            '" id="' +
            id +
            '" class="' +
            cssClassString +
            '" reference="' +
            reference +
            '" targetclass="' +
            targetClass +
            '" value="' +
            defaultValue +
            '" default_value="' +
            defaultValue +
            '" data-description="' +
            description +
            '" placeholder="' +
            placeholder +
            '" data-caption="' +
            caption +
            '" />';

          break;
      }
      return template;
    };

    this.renderForm = function (fields) {
      // Set Responsive
      const screenType =
        $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';

      const _iconButtonReponsive = utils.chooseResponsiveIcon(screenType);

      let _template = '<div class="rows" style="width:100%">';
      for (let i = 0; i < fields.length; i++) {
        const field = fields[i];
        const id = field.id != undefined ? field.id : '';
        const caption = field.caption != undefined ? field.caption : '';
        let visible = field.visible != undefined ? field.visible : '';
        const className = field.class != undefined ? field.class : '';
        const advanced = field.advanced != undefined ? 'data-advanced="true"' : '';
        const resposive = field.mode != undefined ? 'data-responsive="true"' : '';

        // Check no render column settings
        let noRender = '';
        if (className.indexOf('no-render') != -1) {
          noRender = 'data-render="no-render"';
        }

        switch (id) {
          case 'bHandle':
          case 'bId':
          case 'cHandle':
          case 'cId':
            visible = 'field-hide-all';
            break;
        }

        _template += '<div class="columns ' + visible + '" ' + resposive + ' ' + advanced + ' ' + noRender + '>';
        // Template
        if (field.type != 'div' && className.indexOf('gf-options') == -1) {
          _template += '<div class="gfSGBackground"></div>';
          _template += '<div class="gfSettingGroup">';
          _template += '<div class="gfSGBarHover">';
          _template += '<div class="gfSGBarHoverTitle">';
          _template +=
            '<svg class="help-me-name-it-bruh" height="5px" viewBox="0 0 29 5"><path d="M13,0v4h-1V0H13z M6,0h5v5H6V0z M7,4h3V1H7V4z M13,5h3V4h-3V5z M16,4h1V0h-1V4z M4,2H1V0H0v5h1V3h3v2h1V0H4V2zM28,3v1h-1V3h-2v2h-1V0h1h3h1v3H28z M28,2V1h-3v1H28z M29,5V4h-1v1H29z M23,1V0h-5v5h5V4h-4V3h4V2h-4V1H23z" style="fill: #2A2A2D;"/></svg>';
          _template += '</div>';
          _template +=
            '<button type="button" class="gfSGBarHoverIcon"><svg class="help-me-name-it-bruh" height="11px" viewBox="0 0 7 11"><path d="M4,5h1v4H4V5z M2,9h1V5H2V9z M7,3v8H0V3H7z M1,10h5V4H1V10z M4,1V0H3v1H0v1h7V1H4z" style="fill: #2A2A2D;"/></svg></button>';
          _template += '</div>';

          const dataCaption = HELPER.removeAllHtmlTag(field.caption);
          if (field.caption) {
            _template += '<div class="gfSGTitleBar">';
            _template += `<div class="gfSGTitleBarTitle" data-caption="${dataCaption}">${caption}</div>`;
            if (field.mode) {
              _template += '<button type="button" class="gfSGTitleBarResposive">' + _iconButtonReponsive + '</button>';
            }
            if (field.hover_mode) {
              _template +=
                '<button type="button" class="gfSGTitleBarHover"><svg class="help-me-name-it-bruh" height="12px" viewBox="0 0 12 12"><path class="st1" d="M6.4,5H11l-7,7l1.6-5H1l7-7L6.4,5z" style="fill: #EBEBEC;"/></svg></button>';
            }
            _template += '</div>';
          }
          _template += '<div class="gfSGResponsive"></div>';
          _template += '<div class="gfSGSettings">';
        }
        // Div == repeator;
        if (field.type == 'group') {
          if (field.items && field.items.length > 0) {
            for (let h = 0; h < field.items.length; h++) {
              const item = field.items[h];
              _template += _this.renderFormField(item);
            }
            if (field.desc) {
              _template += '<div class="gfDescGroup">' + field.desc + '</div>';
            }
          } else {
            _template += _this.renderFormField(field);
          }
        } else {
          _template += _this.renderFormField(field);
        }

        if (field.type != 'div' && className.indexOf('gf-options') == -1) {
          _template += '</div>';
          _template += '</div>';
        }

        _template += '<div class="gfSGPopup"></div>';
        _template += '</div>';

        if (field.advanced != undefined) {
          _template += '<div class="columns-advanced" data-hide="true" ' + resposive + ' data-hover="true">';
          _template += '<div class="gfSGBackground"></div>';
          _template += '<div class="gfSettingGroup">';
          _template += '<div class="gfSGBarHover">';
          _template += '<div class="gfSGBarHoverTitle">';
          _template +=
            '<svg class="help-me-name-it-bruh" height="5px" viewBox="0 0 29 5"><path d="M13,0v4h-1V0H13z M6,0h5v5H6V0z M7,4h3V1H7V4z M13,5h3V4h-3V5z M16,4h1V0h-1V4z M4,2H1V0H0v5h1V3h3v2h1V0H4V2zM28,3v1h-1V3h-2v2h-1V0h1h3h1v3H28z M28,2V1h-3v1H28z M29,5V4h-1v1H29z M23,1V0h-5v5h5V4h-4V3h4V2h-4V1H23z" style="fill: #2A2A2D;"/></svg>';
          _template += '</div>';
          _template +=
            '<button type="button" class="gfSGBarHoverIcon"><svg class="help-me-name-it-bruh" height="11px" viewBox="0 0 7 11"><path d="M4,5h1v4H4V5z M2,9h1V5H2V9z M7,3v8H0V3H7z M1,10h5V4H1V10z M4,1V0H3v1H0v1h7V1H4z" style="fill: #2A2A2D;"/></svg></button>';
          _template += '</div>';

          if (field.caption) {
            _template += '<div class="gfSGTitleBar">';
            if (field.advancedCaption) {
              _template +=
                '<div class="gfSGTitleBarTitle" data-caption="' +
                field.advancedCaption +
                '">' +
                field.advancedCaption +
                '</div>';
            } else {
              _template += '<div class="gfSGTitleBarTitle" data-caption="' + caption + '">' + caption + '</div>';
            }
            if (field.mode) {
              _template += '<button type="button" class="gfSGTitleBarResposive">' + _iconButtonReponsive + '</button>';
            }
            _template += '</div>';
          }
          _template += '<div class="gfSGResponsive"></div>';
          _template += '<div class="gfSGSettings">';

          for (let k = 0; k < field.advanced.length; k++) {
            const fieldAdvance = field.advanced[k];
            _template += _this.renderFormField(fieldAdvance, 'advanced');
          }

          _template += '</div>';
          _template += '</div>';
          _template += '</div>';
        }
      }
      _template += '</div>';

      return _template;
    };

    this.init();
  };
  jQuery.fn.gfFormRender = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfformrender')) {
        const plugin = new jQuery.gfFormRender(this, options);
        jQuery(this).data('gfformrender', plugin);
      }
    });
  };
})(jQuery);
